"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("../../utils");

var StructPropBuilder_1 = require("../data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../DomainObject");
/**
 * A time without timezone, such as 10:15:30.
 * @author VRu
 */


var LocalTime =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(LocalTime, _DomainObject_1$Domai);

  function LocalTime(hour, minute, second) {
    var _this;

    _classCallCheck(this, LocalTime);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(LocalTime).call(this));
    _this.hour = hour;
    _this.minute = minute;
    _this.second = second;
    return _this;
  }

  _createClass(LocalTime, [{
    key: "toString",
    value: function toString() {
      var result = "".concat(utils_1.Utils.padStart(this.hour.toString(), 2, '0'), ":") + "".concat(utils_1.Utils.padStart(this.minute.toString(), 2, '0'), ":") + "".concat(utils_1.Utils.padStart(this.second.toString(), 2, '0'));
      return result;
    }
  }, {
    key: "serialize",
    value: function serialize() {
      return this.toString();
    }
    /**
     * Converter from data-dictionary representation.
     */

  }], [{
    key: "fromDataDict",
    value: function fromDataDict(mat) {
      return new LocalTime(mat.hour, mat.minute, mat.second);
    }
  }]);

  return LocalTime;
}(DomainObject_1.DomainObject);

exports.LocalTime = LocalTime;
LocalTime.MIN = new LocalTime(0, 0, 0);
LocalTime.MAX = new LocalTime(23, 59, 59);

LocalTime.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(LocalTime.name);
  return {
    hour: builder.num('hour'),
    minute: builder.num('minute'),
    second: builder.num('second')
  };
}();